import { useEffect } from 'react';
import { Seo } from '../components/seo';

function KitSuccessPage() {
  useEffect(() => {
    localStorage.removeItem('customerAuthState');
    sessionStorage.removeItem('uniqueId');
  }, []);
  const { VITE_APPLE_STORE_LINK, VITE_GOOGLE_PLAY_LINK } = import.meta.env;

  return (
    <>
      <Seo title="Home" />
      <div className="flex flex-col gap-y-20">
        <div className="flex flex-col gap-y-4">
          <h2 className="font-inter font-bold text-[2rem] text-black">
            Successful Registration
          </h2>
          <p>
            Once your test has been sent over and completed, you will be
            notified by email that your results are available within our app.
            You can download the app using the links below. Your log-in
            credentials will be the email or mobile number and password you
            initially provided during registration.
          </p>
        </div>
        <div className="flex flex-col gap-y-4">
          <p>Download the HeartMap app now!</p>
          <div className="flex gap-x-3">
            <a href={VITE_APPLE_STORE_LINK} target="_blank" rel="noreferrer">
              <img
                src="/app-store-badge.png"
                alt="app-store"
                className="h-14"
              />
            </a>
            <a href={VITE_GOOGLE_PLAY_LINK} target="_blank" rel="noreferrer">
              <img
                src="/google-play-badge.png"
                alt="play-store"
                className="h-14"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default KitSuccessPage;
